// extracted by mini-css-extract-plugin
export var Content = "Pages-module--Content--1zGOD";
export var UnboundedContent = "Pages-module--UnboundedContent--2gFmS";
export var Link = "Pages-module--Link--2gZ4l";
export var Statuses = "Pages-module--Statuses--14X61";
export var Status = "Pages-module--Status--3pruU";
export var ErrorType = "Pages-module--ErrorType--1Fsge";